import Call from '../Call';

const BidderSourcesCountry = {
    get() {
        return Call(`bidderSourcesCountry`);
    },

    save(source) {
        return Call('bidderSourcesCountry','POST', source);
    },

    update(name, source) {
        return Call(`bidderSourcesCountry/${name}`,'PUT', source);
    },

    remove(name) {
        return Call(`bidderSourcesCountry/${name}`,'DELETE');
    },
};

export default BidderSourcesCountry;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderSourcesCountry.js